import { render, staticRenderFns } from "./AllowanceList.vue?vue&type=template&id=86046b52&scoped=true"
import script from "./AllowanceList.vue?vue&type=script&lang=js"
export * from "./AllowanceList.vue?vue&type=script&lang=js"
import style0 from "./AllowanceList.vue?vue&type=style&index=0&id=86046b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86046b52",
  null
  
)

export default component.exports